import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  TextField,
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box
} from '@material-ui/core';
import { Fab, FormControlLabel, Stack } from '@mui/material';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import SendIcon from '@material-ui/icons/Send';
import SaveIcon from '@mui/icons-material/Save';
import CheckIcon from '@mui/icons-material/Check';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import ProjectCreate from './ProjectCreate';
import ProjectSummaryList from './ProjectSummaryList';
import HavcRadioOption from './HavcRadioOption';
import Alert from '@mui/material/Alert';
import { setAlert } from 'src/store/actions';
const SessionUser = getUser();

const initialFormState = {
  ProjectOwner: '',
  BrandId: 0,
  ResponsibleTechnicianId: 0,
  CityId: -1,
  ControlRoomCount: 0,
  CustomerName: '',
  CustomerSurname: '',
  CustomerTel1: '',
  CustomerTel2: '',
  CustomerTel3: '',
  DealerId: 0,
  DealerManagerId: '',
  Description: '',
  DistrictId: -1,
  DraftProject: 1,
  FreshAirCount: 0,
  HeatPumpCount: 0,
  MentorServiceId: 0,
  NeighbourhoodId: -1,
  PdiCount: 0,
  ProjectAddress: '',
  ProjectID: 0,
  RegionId: 0,
  RegistrationDate: '',
  ServiceId: 0,
  ServiceManagerId: 0,
  SystemCount: 0,
  TotalOdu: 0,
  TotalIdu: 0,
  TotalGas: 0,
  Modifier: SessionUser?.UserId ? SessionUser?.UserId : '0',
  Creator: SessionUser?.UserId ? SessionUser?.UserId : '0',
  Active: 1
};

function CreateProjectDialog({ open, setOpen, HavcAddressData, sorgula }) {
  const currentUser = SessionUser?.UserId ? SessionUser?.UserId : "0";
  initialFormState.Modifier = SessionUser?.UserId ? SessionUser?.UserId : "0"; //büyük ihtimalle race condition oluyor yukarda.
  initialFormState.Creator = SessionUser?.UserId ? SessionUser?.UserId : "0";
  const [formData, setFormData] = useState(initialFormState);
  const [durum, setDurum] = React.useState([]);
  const [bolge, setBolge] = React.useState([]);
  const [servis, setServis] = React.useState([]);
  const [bayi, setBayi] = React.useState([]);
  const [mentorServis, setMentorServis] = React.useState([]);
  const [il, setIl] = React.useState([]);
  const [ilce, setIlce] = React.useState([]);
  const [mahalle, setMahalle] = React.useState([]);
  const [phoneRegionCodes, setPhoneRegionCodes] = React.useState([]);
  const [marka, setMarka] = React.useState([]);
  const [merkeziKlima, setMerkemziKlima] = React.useState([]);
  const [servisYonetmeni, setServisYonetmeni] = React.useState([]);
  const [sorumluTeknisyen, setSorumluTeknisyen] = React.useState([]);
  const [data, setData] = useState([]);
  const [projectFiles, setProjectFiles] = useState([]);
  const [projectSummary, setProjectSummary] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertContext, setAlertContext] = useState(
    'Zorunlu alanları lütfen doldurunuz!'
  );
  const [
    projectHizmetlerIscilikler,
    setProjectHizmetlerIscilikler
  ] = React.useState([]);
  const [errors, setErrors] = useState({
    CustomerName: '',
    CustomerSurname: '',
    CityId: '',
    CustomerTel1: '',
    CustomerTel2: '',
    DistrictId: '',
    NeighbourhoodId: '',
    ServiceId: ''
  });

  const testFunc = () => {
    console.clear();
    console.log(formData);
    console.log(data);
    console.log(JSON.stringify(data));
    console.log(projectFiles);
    console.log(projectHizmetlerIscilikler);
    console.log(phoneRegionCodes);
    console.log(
      phoneRegionCodes.some(
        x => x.Dsc === formData.CustomerTel1.substring(0, 3)
      )
    );
    console.log(formData.CustomerTel1.substring(0, 3));
  };

  const validateForm = () => {
    let tempErrors = { ...errors };
    let isValid = true;

    tempErrors.CustomerName = '';
    tempErrors.CustomerSurname = '';
    tempErrors.CustomerTel1 = '';
    tempErrors.CustomerTel2 = '';
    tempErrors.CustomerTel3 = '';
    tempErrors.CityId = '';
    tempErrors.DistrictId = '';
    tempErrors.NeighbourhoodId = '';
    tempErrors.RegionId = '';
    tempErrors.ServiceId = '';

    if (!formData.CustomerName) {
      tempErrors.CustomerName = 'Müşteri Adı gerekli';
      isValid = false;
    }
    if (!formData.CustomerSurname) {
      tempErrors.CustomerSurname = 'Müşteri Soyadı gerekli';
      isValid = false;
    }
    if (!formData.CustomerTel1) {
      tempErrors.CustomerTel1 = 'Tel1 gerekli';
      isValid = false;
    } else if (formData.CustomerTel1.length !== 10) {
      tempErrors.CustomerTel1 = 'Tel1 no 10 haneli bir sayı olmalı';
      isValid = false;
    } else if (/\s/.test(formData.CustomerTel1)) {
      tempErrors.CustomerTel1 = 'Tel1 no boşluk içeremez';
      isValid = false;
    } else if (formData.CustomerTel1.startsWith('0')) {
      tempErrors.CustomerTel1 = 'Tel1 no sıfır ile başlayamaz';
      isValid = false;
    } else if (
      !phoneRegionCodes.some(
        x => x.Dsc === formData.CustomerTel1.substring(0, 3)
      )
    ) {
      tempErrors.CustomerTel1 = 'Tel1 no formatını kontrol ediniz';
      isValid = false;
    }
    // if (!formData.CustomerTel2) {
    //   tempErrors.CustomerTel2 = 'Tel2 gerekli';
    //   isValid = false;
    // } else if (formData.CustomerTel2.length !== 10) {
    //   tempErrors.CustomerTel2 = 'Tel2 no 10 haneli bir sayı olmalı';
    //   isValid = false;
    // } else if (/\s/.test(formData.CustomerTel2)) {
    //   tempErrors.CustomerTel2 = 'Tel2 no boşluk içeremez';
    //   isValid = false;
    // } else if (formData.CustomerTel2.startsWith('0')) {
    //   tempErrors.CustomerTel2 = 'Tel2 no sıfır ile başlayamaz';
    //   isValid = false;
    // } else if (!phoneRegionCodes.some(x => x.Dsc === formData.CustomerTel2.substring(0,3))) {
    //   tempErrors.CustomerTel2 = 'Tel2 no formatını kontrol ediniz';
    //   isValid = false;
    // }
    // if (formData.CustomerTel3 && formData.CustomerTel3.length !== 10) {
    //   tempErrors.CustomerTel3 = 'Tel3 no 10 haneli bir sayı olmalı';
    //   isValid = false;
    // } else if (formData.CustomerTel3 && /\s/.test(formData.CustomerTel3)) {
    //   tempErrors.CustomerTel3 = 'Tel3 no boşluk içeremez';
    //   isValid = false;
    // } else if (formData.CustomerTel3 && formData.CustomerTel3.startsWith('0')) {
    //   tempErrors.CustomerTel3 = 'Tel3 no sıfır ile başlayamaz';
    //   isValid = false;
    // }else if (!phoneRegionCodes.some(x => x.Dsc === formData.CustomerTel3.substring(0,3))) {
    //   tempErrors.CustomerTel3 = 'Tel3 no formatını kontrol ediniz';
    //   isValid = false;
    // }
    if (formData.CityId < 0 || formData.CityId == null) {
      tempErrors.CityId = 'İl seçimi gerekli';
      isValid = false;
    }
    if (formData.DistrictId < 0 || formData.DistrictId == null) {
      tempErrors.DistrictId = 'İlçe seçimi gerekli';
      isValid = false;
    }
    if (formData.NeighbourhoodId < 0 || formData.NeighbourhoodId == null) {
      tempErrors.NeighbourhoodId = 'Mahalle seçimi gerekli';
      isValid = false;
    }
    if (!formData.RegionId) {
      tempErrors.RegionId = 'Bölge seçimi gerekli';
      isValid = false;
    }
    if (!formData.ServiceId) {
      tempErrors.ServiceId = 'Servis seçimi gerekli';
      isValid = false;
    }
    /*
    data
      .filter(x => x.Level === 1)
      .forEach((item, index) => {
        if (!item.OduCount || item.OduCount <= 0) {
          tempErrors[`OduCount${item.Id}`] = 'Dış Ünite Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`OduCount${item.Id}`] = '';
        }
        if (!item.IduCount || item.IduCount <= 0) {
          tempErrors[`IduCount${item.Id}`] = 'İç Ünite Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`IduCount${item.Id}`] = '';
        }
        if (!item.HydrocideCount || item.HydrocideCount <= 0) {
          tempErrors[`HydrocideCount${item.Id}`] = 'Hidrokit Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`HydrocideCount${item.Id}`] = '';
        }
        if (!item.RemoteCount || item.RemoteCount <= 0) {
          tempErrors[`RemoteCount${item.Id}`] = 'Kumanda Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`RemoteCount${item.Id}`] = '';
        }
        if (!item.FrontPanelCount || item.FrontPanelCount <= 0) {
          tempErrors[`FrontPanelCount${item.Id}`] = 'Ön Panel Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`FrontPanelCount${item.Id}`] = '';
        }
        if (!item.HrBoxCount || item.HrBoxCount <= 0) {
          tempErrors[`HrBoxCount${item.Id}`] = 'Hr BOX Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`HrBoxCount${item.Id}`] = '';
        }
        if (!item.IntegrationModuleCount || item.IntegrationModuleCount <= 0) {
          tempErrors[`IntegrationModuleCount${item.Id}`] =
            'Entegrasyon Modül Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`IntegrationModuleCount${item.Id}`] = '';
        }
        if (
          !item.KsCommunicationKitCount ||
          item.KsCommunicationKitCount <= 0
        ) {
          tempErrors[`KsCommunicationKitCount${item.Id}`] =
            'Ks Haberleşme Kit Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`KsCommunicationKitCount${item.Id}`] = '';
        }
        if (!item.EevKitCount || item.EevKitCount <= 0) {
          tempErrors[`EevKitCount${item.Id}`] = 'Eev Kit Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`EevKitCount${item.Id}`] = '';
        }
        if (!item.FdxBoxCount || item.FdxBoxCount <= 0) {
          tempErrors[`FdxBoxCount${item.Id}`] = 'Fdx Box Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`FdxBoxCount${item.Id}`] = '';
        }
        if (!item.AirRouterCount || item.AirRouterCount <= 0) {
          tempErrors[`AirRouterCount${item.Id}`] =
            'Hava Yönlendirici Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`AirRouterCount${item.Id}`] = '';
        }
      });
*/
    if (projectHizmetlerIscilikler.length === 0) {
      setAlertContext('Hizmet ve İşçilik Girilmeli');
      isValid = false;
    } else {
      projectHizmetlerIscilikler?.forEach(item => {
        setAlertContext('Zorunlu alanları lütfen doldurunuz!');
        if (item.hizmetler.length < 1 && item.iscilikler.length < 1) {
          setAlertContext('Hizmet ve İşçilik Girilmeli');
          isValid = false;
        } else {
          if (item.hizmetler.length < 1) {
            setAlertContext('Hizmet Girilmeli');
            isValid = false;
          }
          if (item.iscilikler.length < 1) {
            setAlertContext('Isçilik Girilmeli');
            isValid = false;
          }
        }
      });
    }
    setErrors(tempErrors);
    return isValid;
  };

  useEffect(() => {
    try {
      const mainArray = JSON.parse(
        localStorage.getItem('HavcComboData').replace(/\\"/g, '"')
      );

      setDurum(mainArray[0].DURUM);
      setBolge(mainArray[0].BOLGE);
      setServis(mainArray[0].SERVIS);
      setBayi(mainArray[0].BAYI);
      setMentorServis(mainArray[0].MENTOR_SERVIS);
      setMarka(mainArray[0].MARKA);
      setMerkemziKlima(mainArray[0].MERKEZI_KLIMALAR);
      setServisYonetmeni(mainArray[0].SERVIS_YONETMENI);
      setSorumluTeknisyen(mainArray[0].SORUMLU_TEKNISYEN);
      setPhoneRegionCodes(mainArray[0].PHONE_REGION_CODES);
      setIl(HavcAddressData[0].IL);
      setIlce(HavcAddressData[0].ILCE);
      setMahalle(HavcAddressData[0].MAHALLE);
    } catch (error) {
      console.log('Bir hata oluştu.');
    }
  }, []);

  const handleAutocompleteSelect = property => (event, newValue) => {
    if (property === 'CityId') {
      formData.DistrictId = null;
      formData.NeighbourhoodId = null;
    }
    if (property === 'DistrictId') {
      formData.NeighbourhoodId = null;
    }
    if (property === 'RegionId') {
      formData.ServiceId = null;
    }

    setFormData(prevData => ({
      ...prevData,
      [property]: newValue ? newValue.Id : null
    }));
  };

  const handleInputChange = e => {
    let { name, value } = e.target;

    value =
      name === 'DraftProject'
        ? e.target.checked === true
          ? 1
          : 0
        : e.target.value;

    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const getLabel = (pID, currentLevel, i) => {
    const index = data.filter(x => x.Level === currentLevel).length + i;

    switch (currentLevel) {
      case 0:
        return `Merkezi Kumanda-${parseInt(index) + 1}`;
      case 1:
        return `Sistem-${parseInt(index) + 1}`;
      case 2:
        return `ODU-${parseInt(index) + 1}`;
      case 3:
        return `IDU-${parseInt(index) + 1}`;
      default:
        return `Label-${index + 1}`;
    }
  };

  const handleOnChange = (level, prop, newVal, parentID) => {
    let newValue;
    if (newVal) {
      newValue = newVal?.Id ? newVal?.Id : newVal;
    }
    const lastVal = parseInt(
      data.filter(x => x.Level === level && x.DerivationFrom === 0).length
    );
    const newValInt = parseInt(newVal);

    if (lastVal > parseInt(newVal)) {
      const idsToDelete = data
        .filter(
          item => item.Level === level && item.DerivationFrom === parentID
        )
        .sort((a, b) => b.Id - a.Id)
        .slice(0, lastVal - newValInt)
        .map(item => item.Id);

      idsToDelete.forEach(id => handleDelete(id));
    } else {
      const arrLength =
        parseInt(newVal) - data.filter(x => x.Level == level).length;
      const newElementId =
        data && data.length > 0 ? Math.max(...data.map(item => item.Id)) : 0;
      const newObjects = Array.from(
        { length: parseInt(arrLength) },
        (_, index) => ({
          AdditionalGasAmount: 0.0,
          AirRouterCount: 0,
          BranchCollectorCount: 0,
          Cable12_7mm: 0.0,
          Cable15_88mm: 0.0,
          Cable19_05mm: 0.0,
          Cable22_22mm: 0.0,
          Cable25_4mm: 0.0,
          Cable28_88mm: 0.0,
          Cable34_92mm: 0.0,
          Cable41_28mm: 0.0,
          Cable6_35mm: 0.0,
          Cable9_52mm: 0.0,
          CommissioningDate: '',
          ControlRoomModel: 0,
          ControlRoomModelNote: '',
          Creator: SessionUser?.UserId ? SessionUser?.UserId : 0,
          DerivationFrom: 0,
          DryContactCount: 0,
          DxCount: 0,
          EevKitCount: 0,
          FdxBoxCount: 0,
          FisNo: 0,
          FreshAirDxCount: 0,
          FrontPanelCount: 0,
          HrBoxCount: 0,
          HydrocideCount: 0,
          Id: newElementId + index + 1,
          IduCount: 0,
          IntegrationModuleCount: 0,
          KsCommunicationKitCount: 0,
          KsDxCount: 0,
          Level: level,
          LineStatus: 'N',
          Modifier: SessionUser?.UserId ? SessionUser?.UserId : 0,
          OduCount: 0,
          PreGasAmount: 0.0,
          ProjectID: 0,
          RemoteCount: 0,
          SystemCapacity: 0.0,
          SystemControlRoomModel: 0,
          SystemName: getLabel(0, level, index),
          SystemNote: '',
          SystemRepeatCount: 1,
          SystemStatus: 0,
          SystemTotalGas: 0.0,
          ContractDate: ''
        })
      );

      setData(prev => [...prev, ...newObjects]);
    }
  };

  const handleDelete = parentId => {
    const deleteNode = id => {
      setData(prevData => prevData.filter(item => item.Id !== id));
      const children = data.filter(item => item.DerivationFrom === id);
      children.forEach(child => deleteNode(child.Id));
    };

    const parentNode = data.find(item => item.Id === parentId);
    if (parentNode) {
      deleteNode(parentId);
    }
  };

  const setGonder = () => {
    if (!validateForm()) {
      setProjectSummary(false);
      setShowAlert(true);
      return;
    }

    if (!loading) {
      setLoading(true);
    }

    let formDataArray = [];

    const FilesData = projectFiles
      .filter(x => x.active === 1)
      .map(file => ({
        id: file.id,
        fileType: file.fileType,
        fileData: file.fileData,
        fileName: file.fileName,
        fileSystem: file.fileSystem,
        active: file.active,
        fromDb: file.fromDb
      }));

    const hizmetIscilikData = projectHizmetlerIscilikler.map(item => ({
      Id: item.id,
      hizmetler: item.hizmetler.map(h => h.Id).join(','),
      iscilikler: item.iscilikler.map(i => i.Id).join(',')
    }));

    formDataArray.push(formData);
    const body = {
      header: formDataArray,
      detail: data,
      files: FilesData,
      hizmetIscilik: hizmetIscilikData
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('HavcProjectCreate', body, config)
      .then(response => {
        setData([]);
        setProjectHizmetlerIscilikler([]);
        setFormData(initialFormState);
        setProjectFiles([]);
        setErrors([]);
        setLoading(false);
        setShowAlert(false);
        setProjectSummary(false);
        setOpen(false);
        sorgula();
      })
      .catch(error => { setLoading(false); });
  };

  const handleDialogClose = () => {
    setData([]);
    setProjectHizmetlerIscilikler([]);
    setFormData(initialFormState);
    setProjectFiles([]);
    setErrors([]);
    setLoading(false);
    setShowAlert(false);
    setProjectSummary(false);
    setOpen(false);
  };

  return (
    <>
      <React.Fragment>
        <Dialog
          open={open}
          fullWidth
          maxWidth="lg"
          onClose={() => setOpen(false)}
          disableBackdropClick
        >
          <DialogTitle>HVAC ve Enerji Çözümleri Proje Oluşturma</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    autoFocus
                    type="text"
                    placeholder="Proje Adı"
                    variant="outlined"
                    name="ProjectOwner"
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    autoFocus
                    type="text"
                    placeholder="Müşteri Adı"
                    variant="outlined"
                    name="CustomerName"
                    error={Boolean(errors.CustomerName)}
                    helperText={errors.CustomerName}
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    autoFocus
                    type="text"
                    placeholder="Müşteri Soyadı"
                    variant="outlined"
                    name="CustomerSurname"
                    error={Boolean(errors.CustomerSurname)}
                    helperText={errors.CustomerSurname}
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    autoFocus
                    type="text"
                    placeholder="Müşteri Tel1"
                    variant="outlined"
                    name="CustomerTel1"
                    error={Boolean(errors.CustomerTel1)}
                    helperText={errors.CustomerTel1}
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    autoFocus
                    type="text"
                    placeholder="Müşteri Tel2"
                    variant="outlined"
                    name="CustomerTel2"
                    error={Boolean(errors.CustomerTel2)}
                    helperText={errors.CustomerTel2}
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    autoFocus
                    type="text"
                    placeholder="Müşteri Tel3"
                    variant="outlined"
                    name="CustomerTel3"
                    error={Boolean(errors.CustomerTel3)}
                    helperText={errors.CustomerTel3}
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="CityId"
                    name="CityId"
                    fullWidth
                    options={HavcAddressData[0]?.IL}
                    getOptionLabel={il => (il.Dsc ? il.Dsc : '')}
                    onChange={handleAutocompleteSelect('CityId')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="İl"
                        variant="outlined"
                        error={Boolean(errors.CityId)}
                        helperText={errors.CityId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="DistrictId"
                    name="DistrictId"
                    fullWidth
                    options={HavcAddressData[0]?.ILCE.filter(
                      item => item.IlId == formData.CityId
                    )}
                    getOptionLabel={ilce => (ilce.Dsc ? ilce.Dsc : '')}
                    value={
                      HavcAddressData[0]?.ILCE?.find(
                        x =>
                          x.Id === formData.DistrictId &&
                          parseInt(x.IlId) === parseInt(formData.CityId)
                      ) || null
                    }
                    onChange={handleAutocompleteSelect('DistrictId')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="İlçe"
                        variant="outlined"
                        error={Boolean(errors.DistrictId)}
                        helperText={errors.DistrictId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="NeighbourhoodId"
                    name="NeighbourhoodId"
                    fullWidth
                    options={HavcAddressData[0]?.MAHALLE.filter(
                      item =>
                        parseInt(item.IlId) === parseInt(formData.CityId) &&
                        item.IlceId === formData.DistrictId
                    )}
                    getOptionLabel={mahalle => (mahalle.Dsc ? mahalle.Dsc : '')}
                    value={
                      HavcAddressData[0]?.MAHALLE.find(
                        x => x.Id === formData.NeighbourhoodId
                      ) || null
                    }
                    onChange={handleAutocompleteSelect('NeighbourhoodId')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Mahalle"
                        variant="outlined"
                        error={Boolean(errors.NeighbourhoodId)}
                        helperText={errors.NeighbourhoodId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="RegionId"
                    name="RegionId"
                    fullWidth
                    options={bolge}
                    getOptionLabel={bolge => (bolge.Dsc ? bolge.Dsc : '')}
                    onChange={handleAutocompleteSelect('RegionId')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Bölge"
                        variant="outlined"
                        error={Boolean(errors.RegionId)}
                        helperText={errors.RegionId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="ServiceId"
                    name="ServiceId"
                    fullWidth
                    options={servis.filter(
                      x => x.BolgeId === formData.RegionId
                    )}
                    getOptionLabel={servis => (servis.Dsc ? servis.Dsc : '')}
                    value={
                      servis.find(x => x.Id === formData.ServiceId) || null
                    }
                    onChange={handleAutocompleteSelect('ServiceId')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Servis"
                        variant="outlined"
                        error={Boolean(errors.ServiceId)}
                        helperText={errors.ServiceId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="MentorServiceId"
                    name="MentorServiceId"
                    fullWidth
                    options={mentorServis}
                    getOptionLabel={mentorServis =>
                      mentorServis.Dsc ? mentorServis.Dsc : ''
                    }
                    onChange={handleAutocompleteSelect('MentorServiceId')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Proje Destek Servisi"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="DealerId"
                    name="DealerId"
                    fullWidth
                    options={bayi}
                    getOptionLabel={bayi => (bayi.Dsc ? bayi.Dsc : '')}
                    onChange={handleAutocompleteSelect('DealerId')}
                    renderInput={params => (
                      <TextField {...params} label="Bayi" variant="outlined" />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="BrandId"
                    name="BrandId"
                    fullWidth
                    options={marka}
                    getOptionLabel={marka => (marka.Dsc ? marka.Dsc : '')}
                    onChange={handleAutocompleteSelect('BrandId')}
                    renderInput={params => (
                      <TextField {...params} label="Marka" variant="outlined" />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="ResponsibleTechnicianId"
                    name="ResponsibleTechnicianId"
                    fullWidth
                    options={sorumluTeknisyen}
                    getOptionLabel={teknisyen =>
                      teknisyen.Dsc ? teknisyen.Dsc : ''
                    }
                    onChange={handleAutocompleteSelect(
                      'ResponsibleTechnicianId'
                    )}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Sorumlu Teknisyen"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    id="ServiceManagerId"
                    name="ServiceManagerId"
                    fullWidth
                    options={servisYonetmeni}
                    getOptionLabel={servis => (servis.Dsc ? servis.Dsc : '')}
                    onChange={handleAutocompleteSelect('ServiceManagerId')}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Servis Yönetmeni"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    type="text"
                    label="Bayi Yönetmeni"
                    name="DealerManagerId"
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Kayıt Tarihi"
                    variant="outlined"
                    type="date"
                    InputLabelProps={{ shrink: true, required: true }}
                    name="RegistrationDate"
                    onChange={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    id="ProjectAddress"
                    name="ProjectAddress"
                    label="Açık Adres"
                    variant="outlined"
                    type="text"
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    label="Sözleşme Tarihi"
                    variant="outlined"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    name="ContractDate"
                    value={formData?.ContractDate?.split('T')[0]}
                    onChange={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    type="number"
                    label="Merkezi Kumanda Sayısı"
                    name="ControlRoomCount"
                    value={formData.ControlRoomCount}
                    onChange={event => {
                      handleInputChange(event);
                    }}
                    onBlur={event => {
                      handleOnChange(
                        0,
                        'ControlRoomCount',
                        event.target.value,
                        0
                      );
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    type="number"
                    label="Sistem Sayısı"
                    name="SystemCount"
                    value={formData.SystemCount}
                    onChange={event => {
                      handleInputChange(event);
                    }}
                    onBlur={event => {
                      handleOnChange(1, 'SystemCount', event.target.value, 0);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    type="number"
                    label="Isı Pompası"
                    name="HeatPumpCount"
                    value={formData.HeatPumpCount}
                    onChange={event => {
                      handleInputChange(event);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <FormControl fullWidth>
                  <TextField
                    id="PdiCount"
                    name="PdiCount"
                    type="number"
                    label="PDI"
                    variant="outlined"
                    value={formData.PdiCount}
                    onChange={event => {
                      handleInputChange(event);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <FormControl fullWidth>
                  <TextField
                    id="FreshAirCount"
                    name="FreshAirCount"
                    type="number"
                    label="Taze Hava"
                    variant="outlined"
                    value={formData.FreshAirCount}
                    onChange={event => {
                      handleInputChange(event);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <FormControl fullWidth>
                  <TextField
                    type="number"
                    name="TotalOdu"
                    label="Toplam Odu Adet"
                    variant="outlined"
                    value={
                      data
                        ? data
                          .filter(x => x.Level === 1)
                          .reduce(
                            (total, item) =>
                              total + parseInt(item.OduCount, 10),
                            0
                          )
                        : 0
                    }
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    type="number"
                    label="Toplam Idu Adet"
                    name="TotalIdu"
                    value={
                      data
                        ? data
                          .filter(x => x.Level === 1)
                          .reduce(
                            (total, item) =>
                              total + parseInt(item.IduCount, 10),
                            0
                          )
                        : 0
                    }
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <FormControl fullWidth>
                  <TextField
                    id="TotalGas"
                    type="number"
                    name="TotalGas"
                    label="Proje Toplam Gaz Miktarı"
                    variant="outlined"
                    value={
                      data
                        ? data
                          .filter(x => x.Level === 1)
                          .reduce(
                            (total, item) =>
                              total + parseFloat(item.SystemTotalGas),
                            0
                          )
                        : 0
                    }
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <ProjectCreate
                    data={data}
                    setData={setData}
                    projectFiles={projectFiles}
                    setProjectFiles={setProjectFiles}
                    errors={errors}
                    setErrors={setErrors}
                    projectHizmetlerIscilikler={projectHizmetlerIscilikler}
                    setProjectHizmetlerIscilikler={
                      setProjectHizmetlerIscilikler
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    multiline
                    minRows={4}
                    placeholder="Açıklama"
                    name="Description"
                    // onChange={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <HavcRadioOption
              name="DraftProject"
              value={formData.DraftProject ? true : false}
              onChange={handleInputChange}
              size="medium"
            />
            {currentUser === '26120227' && (
              <Button
                variant="contained"
                color="secondary"
                endIcon={<CloseIcon>Call</CloseIcon>}
                onClick={() => testFunc()}
                autoFocus
              >
                Log
              </Button>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={loading}
                  endIcon={<SaveIcon>Call</SaveIcon>}
                  onClick={() => {
                    formData.DraftProject ?
                      setGonder() : setProjectSummary(true)
                  }}
                  autoFocus
                >
                  Kaydet
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: '#ff9800',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px'
                    }}
                  />
                )}
              </Box>
            </Box>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Call</CloseIcon>}
              onClick={handleDialogClose}
              autoFocus
            >
              Kapat
            </Button>
          </DialogActions>
          {showAlert && <Alert severity="error">{alertContext}</Alert>}
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          open={projectSummary}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">
            {'Projede oluşacak fiş adetleri'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <ProjectSummaryList data={data} formData={formData} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon></CloseIcon>}
              onClick={() => setProjectSummary(false)}
            >
              Hayır
            </Button>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CheckIcon></CheckIcon>}
              onClick={() => setGonder()}
              autoFocus
            >
              Evet
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
}

export default CreateProjectDialog;
